export default "__VITE_ASSET__a28cfeab__"